module.exports = __webpack_public_path__ + "img/logo-black.82b303f3.svg";